import { ref } from "vue";
import { WecomaConstants } from "./gdpr/wecoma-constants";
import { httpClient } from "./http-clients/http-client";
import { ContactWecomaKeys, type PlayerContact } from "./models/contact";
import { useLocalStorage } from "./use-storage";

export const wecomaKeysReady = ref(false);

export async function logLogin(contact: PlayerContact, playerId?: string) {
    const response = await httpClient.post<ContactWecomaKeys>("/api/player/login", {
        playerId: playerId ?? "",
        contact: contact,
    });

    const storage = useLocalStorage();
    storage.setJson<ContactWecomaKeys>(WecomaConstants.WECOMA_KEY_STORAGE, response.data, "essential");
    wecomaKeysReady.value = true;
}
